import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const inputVariants = cva(
  'file:text-foreground placeholder:text-placeholder-foreground selection:bg-selection selection:text-selection-foreground border-input flex w-full min-w-0 rounded-md border bg-card text-foreground transition-[background-color,border-color,box-shadow,color] outline-none file:inline-flex file:border-0 file:bg-transparent file:font-medium disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
  {
    variants: {
      size: {
        default: 'h-10 px-3 py-1 text-base file:h-7 file:text-sm md:text-sm',
        sm: 'h-8 px-2 py-1 text-sm file:h-6 file:text-xs',
        xs: 'h-7 px-2 py-1 text-xs file:h-5 file:text-xs',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

export type InputProps = Omit<React.ComponentProps<'input'>, 'size' | 'ref'> &
  VariantProps<typeof inputVariants>

const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, size = 'default', type, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      data-size={size}
      className={cn(inputVariants({ size }), className)}
      {...props}
    />
  )
})

export { Input, inputVariants }
